var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#15225D;}\n\t.st1{clip-path:url(#SVGID_00000160179073874131745860000008518898402301578405_);fill:#212D65;}\n\t.st2{fill:#212D65;}\n\t.st3{clip-path:url(#SVGID_00000026846418541298378560000007067718491000712380_);fill:#212D65;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000065072892476701121540000011773816137477585306_",
    x: 102.5,
    y: 142.5,
    width: 406.6,
    height: 327.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057123014572113935140000005943192405530198700_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065072892476701121540000011773816137477585306_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000057123014572113935140000005943192405530198700_)",
      fill: "#212D65"
    },
    d: "M488.6,277.9 c13.4-14.6,20.5-31.8,20.5-49.9c0-47.1-48.9-85.5-109.1-85.5c-39.2,0-74.6,16-94.2,42.2c-19-25.2-54-42.2-94.1-42.2 c-60.2,0-109.1,38.4-109.1,85.5c0,18.1,7.1,35.3,20.5,49.9L112.4,310c-0.5,1.6-0.1,3.4,1.2,4.6c0.8,0.8,1.9,1.2,3.1,1.2 c0.6,0,1.1-0.1,1.7-0.3l36.4-14.6c17.1,8.2,36.8,12.6,57,12.6c4,0,7.9-0.2,11.9-0.5C208.7,329,200,348.7,200,370 c0,20.7,8.1,40.4,23.5,57l-12.4,37.2c-0.5,1.6-0.1,3.5,1.2,4.6c0.8,0.8,1.9,1.2,3.1,1.2c0.6,0,1.1-0.1,1.7-0.3l41.9-16.9 c19.6,9.5,42.1,14.5,65.3,14.5c68.6,0,124.3-43.7,124.3-97.3c0-22-9.3-42.2-25.1-58.5c11.8-2,23-5.6,33.4-10.6l36.4,14.6 c0.5,0.2,1.1,0.3,1.7,0.3c1.1,0,2.2-0.4,3.1-1.2c1.3-1.2,1.7-3,1.2-4.6L488.6,277.9 M156.9,292.1c-1.2-0.6-2.5-0.6-3.7-0.2 L124,303.7l8.5-25.5c0.5-1.6,0.1-3.3-1-4.5c-13-13.3-19.8-29.1-19.8-45.7c0-42.2,44.9-76.6,100.1-76.6 c55.2,0,100.1,34.4,100.1,76.6c0,17.8-8.2,35-23,48.7c-20.9,4.8-39.4,13.9-54.2,25.8c-7.5,1.4-15.2,2-23,2 C192.2,304.6,173.2,300.3,156.9,292.1z M324.3,458.5c-22.5,0-44.3-5-63.1-14.4c-0.6-0.3-1.3-0.5-2-0.5c-0.6,0-1.1,0.1-1.7,0.3 l-34.8,14l10.2-30.6c0.5-1.6,0.1-3.3-1-4.5c-15-15.4-22.9-33.6-22.9-52.8c0-48.8,51.8-88.4,115.4-88.4c34.5,0,65.4,11.6,86.6,30 c0.1,0.1,0.2,0.1,0.2,0.2c17.8,15.6,28.6,35.9,28.6,58.2C439.7,418.8,387.9,458.5,324.3,458.5z M458.5,291.9 c-1.2-0.5-2.5-0.4-3.7,0.2c-12.1,6.1-25.4,10-39.6,11.6c-22.7-19.1-55.1-31-90.9-31c-7,0-13.9,0.5-20.6,1.3 c11.1-13.7,17.2-29.6,17.2-46.1c0-12.6-3.5-24.5-9.7-35.3c17.2-25.2,51.7-41.3,88.9-41.3c55.2,0,100.1,34.4,100.1,76.6 c0,16.6-6.9,32.4-19.8,45.7c-1.2,1.2-1.6,2.9-1,4.5l8.5,25.5L458.5,291.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000057123014572113935140000005943192405530198700_)",
      fill: "#212D65"
    },
    d: "M352.7,325.8 c-12.1,0-22.7,6.5-28.4,16.2c-5.7-9.7-16.3-16.2-28.4-16.2c-18.1,0-32.9,14.6-32.9,32.6c0,3.7,0.6,7.3,1.8,10.7 c0.9,3.7,8.9,31.2,57.4,56c0.6,0.3,1.3,0.5,2.1,0.5c0.7,0,1.4-0.2,2.1-0.5c48.5-24.8,56.5-52.3,57.4-56c1.2-3.4,1.8-7,1.8-10.7 C385.6,340.4,370.8,325.8,352.7,325.8 M375.2,366.4c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.3-5.9,25.5-50.7,49.2 c-44.9-23.6-50.7-48.9-50.7-49.2s-0.1-0.4-0.2-0.7c-0.9-2.6-1.4-5.2-1.4-8c0-13.1,10.7-23.7,23.9-23.7c13.2,0,23.9,10.6,23.9,23.7 c0,2.5,2,4.4,4.5,4.4c2.5,0,4.5-2,4.5-4.4c0-13.1,10.7-23.7,23.9-23.7c13.2,0,23.9,10.6,23.9,23.7 C376.6,361.1,376.1,363.8,375.2,366.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000057123014572113935140000005943192405530198700_)",
      fill: "#212D65"
    },
    d: "M244.2,271.3h5.7 c9.8,0,17.9-7.9,17.9-17.7v-29.8c0-9.8-8-17.7-17.9-17.7h-16.2l5.7-20.3c1.3-4.5,0.3-9.2-2.5-12.9c-2.8-3.7-7.2-5.8-12-5.8 c-5.8,0-11.1,3.4-13.5,8.5l-8.6,18.3c-3.5,7.4-11,12.2-19.2,12.2h-23.5c-2.5,0-4.5,2-4.5,4.4c0,2.5,2,4.4,4.5,4.4h23.5 c11.7,0,22.4-6.8,27.3-17.3l8.6-18.3c1-2.1,3.1-3.4,5.6-3.4c1.9,0,3.6,0.8,4.7,2.3c1.1,1.5,1.5,3.3,1,5.1l-7.3,25.9 c-0.1,0.2-0.1,0.5-0.1,0.7c-5.8,4-9.6,10.7-9.6,18.2v20.8c0,5,1.7,9.6,4.5,13.3h-58.1c-2.5,0-4.5,2-4.5,4.4s2,4.4,4.5,4.4H244.2  M222.7,249.1v-20.8c0-7.3,6-13.3,13.4-13.3H250c4.9,0,8.9,4,8.9,8.8v29.8c0,4.9-4,8.8-8.9,8.8h-13.8 C228.8,262.4,222.7,256.4,222.7,249.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000057123014572113935140000005943192405530198700_)",
      fill: "#212D65"
    },
    d: "M356.2,220.6 c-10.8,0-10.8,16.6,0,16.6C367,237.3,367.1,220.6,356.2,220.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000057123014572113935140000005943192405530198700_)",
      fill: "#212D65"
    },
    d: "M405.2,220.6 c-10.8,0-10.8,16.6,0,16.6C416,237.3,416,220.6,405.2,220.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000057123014572113935140000005943192405530198700_)",
      fill: "#212D65"
    },
    d: "M454.2,220.6 c-10.8,0-10.8,16.6,0,16.6C465,237.3,465,220.6,454.2,220.6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.719f5686e19276385bcbfaed6cf47d01.svg";
export { ForwardRef as ReactComponent };